import React from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_VISIBLE_MARKERS } from './constants';
import './LimitWarning.css';

function LimitWarning({ hiddenCount, onClose }) {
  const { t } = useTranslation(['discover']);

  if (hiddenCount === 0) {
    return null;
  }

  return (
    <div className="map-limit-warning">
      <div className="map-limit-warning-content">
        <span className="map-limit-warning-icon">⚠️</span>
        <div className="map-limit-warning-text">
          <strong>
            {t('discover.map.limitExceeded', { limit: MAX_VISIBLE_MARKERS }, `Przekroczono limit ${MAX_VISIBLE_MARKERS} markerów`)}
          </strong>
          <p>{t('discover.map.zoomInHint', 'Powiększ obszar, aby zobaczyć więcej wydarzeń')}</p>
        </div>
        <button
          className="map-limit-warning-close"
          onClick={onClose}
          type="button"
          aria-label={t('shared.close', 'Zamknij')}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default LimitWarning;
